import React from "react";

const ASP_Certificate = () => {
  return (
    <div className="tutorial-page">
      <h1>ASP Certificate</h1>
      <p>This is the ASP Certificate page content.</p>
    </div>
  );
};

export default ASP_Certificate;
